import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCommonModule } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { AddBusinessPartnerPhoneComponent } from "app/modules/components/business-partners/business-partner/business-partner-phone-modal/business-partner-phone.component";
import { DeleteConfirmationComponent } from "app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";

@Component({
  selector: "app-sales-office-phone-section",
  templateUrl: "./sales-office-phone-section.component.html",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatCommonModule,
    MatSlideToggleModule,
    AddBusinessPartnerPhoneComponent,
    FormSectionComponent,
  ],
})
export class SalesOfficePhoneSectionComponent {
  @Input() phones: PhoneAttributes[] = [];
  @Output() phonesChange = new EventEmitter<PhoneAttributes>();
  @Output() phoneDelete = new EventEmitter<PhoneAttributes>();
  @Output() phoneStatusChange = new EventEmitter<{
    phone: PhoneAttributes;
    newStatus: boolean;
  }>();

  displayedColumnsPhone: string[] = ["type", "prefix", "statusId", "actions"];

  constructor(private dialog: MatDialog) {}

  openPhoneModal(existingData?: PhoneAttributes) {
    const dialogRef = this.dialog.open(AddBusinessPartnerPhoneComponent, {
      width: "90vw",
      maxWidth: "600px",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: PhoneAttributes) => {
      if (!result) return;
      this.phonesChange.emit({ ...result, _id: existingData?._id });
    });
  }

  openDeletePhone(phone: PhoneAttributes) {
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      data: phone,
      panelClass: "delete-modal",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.phoneDelete.emit(phone);
      }
    });
  }

  onStatusToggle(checked: boolean, phone: PhoneAttributes) {
    this.phoneStatusChange.emit({ phone, newStatus: checked });
  }
}
